/* src/app/notification-settings/location-settings-grid/status-change-notifications/status-change-notifications.component.scss */
.status-change-notifications {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
}
on-off-toggle.left-offset {
  padding-left: 0.5rem;
}
.status-settings {
  display: grid;
  grid-template-columns: max-content max-content max-content max-content max-content;
  column-gap: 15px;
}
.form-check {
  padding: 0px 0px 0px 5px;
}
.form-group {
  padding: 0px 0px 0px 5px;
}
input[type=checkbox] {
  display: none;
}
.form-check label {
  padding: 5px;
  margin-left: -10px;
}
.form-check .checkbox:before {
  display: inline-block;
  content: "";
  width: 24px;
  height: 24px;
  color: black;
  border: 1px solid #979797;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
}
input[type=checkbox]:checked + .checkbox:before {
  color: #00857D;
  content: "\e622" !important;
  font-size: 11px;
  font-family: upsicons, fantasy !important;
  background: #fff;
  text-align: center;
  line-height: 24px;
  font-weight: bolder;
}
.checkbox.disabled:before {
  cursor: default !important;
  background-color: lightgray !important;
}
.info {
  color: #356DAE;
}
/*# sourceMappingURL=status-change-notifications.component.css.map */
